'use strict';

import angular from 'angular';
import ChangePasswordController from './change-password.controller';

export default angular.module('conduuApp.changePassword', [])
  .controller('ChangePasswordController', ChangePasswordController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/change-password/index.js